var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.question.Description)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.question.Description2)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.question.Description3)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66ef7344","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/surveys/types/Info.vue
// module id = null
// module chunks = 